<template src="./index.html"></template>
<script>
	import {
		getdata
	} from './data.js';
	import {
		findConpanyConfig
	} from '../../../../../../api/Draftgeneration.js';
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headDataI: getdata().headDataI,
				// tableDataI: getdata().tableDataI,
				headDataII: getdata().headDataII,
				// tableDataII: getdata().tableDataII,
				delCells: [],
			};
		},
		props: {
			params: {
				type: Object,
				default: {}
			},
			showpz: {
				type: Boolean,
				default: false
			},
			tableDataI: {
				type: Array,
				default: []
			},
			tableDataII: {
				type: Array,
				default: []
			},
			optionxfs: {
				type: Array,
				default: []
			},
			headobj: {
				type: Object,
				default: {}
			},
			choosecellCode: {
				type: String,
				default: ''
			},
			type: {
				type: String,
				default: ''
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			}
		},
		created() {},
		methods: {
			changeXfs(e, ve, index) {
				optionxdansha(this.optionxfs)

				function optionxdansha(data) {
					ve['xfs_0_x_0.1'].cellType = '1'
					ve['xfs_0_x_0.2'].cellType = '1'
					data.forEach(item => {
						if (item.value == e) {
							ve['xfs_0_x_0.2'].cellVal = item.label
							if (item.type == '1') {
								ve['xfs_0_x_2'].cellVal = (parseFloat(item.shuil) * 100).toFixed(2)
								ve['xfs_0_x_1'].cellVal = '0'
								ve['xfs_0_x_3'].cellVal = ''
							} else if (item.type == '2') {
								ve['xfs_0_x_1'].cellVal = (item.shuil).toString()
								ve['xfs_0_x_2'].cellVal = '0'
								ve['xfs_0_x_3'].cellVal = item.jldw
							}
						} else {
							if (item.children) {
								optionxdansha(item.children)
							}
						}
					})
				}
				this.$emit('forhover', 'tableDataI_I', 'xfs_0_x_1', index);
				this.$emit('inputblur', ve['xfs_0_x_1']);
				this.$emit('forhover', 'tableDataI_I', 'xfs_0_x_2', index);
				this.$emit('inputblur', ve['xfs_0_x_2']);
				this.$emit('forhover', 'tableDataI_I', 'xfs_0_x_0.1', index);
			},
			headchange() {
				this.$emit('headchange', this.headobj);
			},
			inputblur(e) {
				this.$emit('inputblur', e);
			},
			forhover(table, colum, index) {
				this.$emit('forhover', table, colum, index);
			},
			zcsclick(e) {
				this.$emit('zcsclick', e);
			},
			fordelete(index) {
				if (this.tableDataI.length < 3) {
					return false;
				}
				if (this.$notemptyandnull(this.tableDataI[index]['xfs_0_x_1'].id)) {
					this.delCells.push(JSON.parse(JSON.stringify(this.tableDataI[index])));
				}
				this.tableDataI.splice(index, 1);
				this.$emit('delCellsCode', this.delCells, 'IHead');
			},
			foraddhang() {
				let hanh = this.tableDataI.length - 1
				this.tableDataI.splice(this.tableDataI.length - 1, 0, {
					hanh: hanh,
					disablednoty_xfs6: true,
					"xfs_0_x_0.1": {
						cellCode: "xfs_0_" + hanh + "_0.1",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_0_x_0.2": {
						cellCode: "xfs_0_" + hanh + "_0.2",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					xfs_0_x_1: {
						cellCode: "xfs_0_" + hanh + "_1",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					xfs_0_x_2: {
						cellCode: "xfs_0_" + hanh + "_2",
						cellType: "0",
						cellVal: "0.00",
						updateDesc: '',
						map: {}
					},
					xfs_0_x_3: {
						cellCode: "xfs_0_" + hanh + "_3",
						cellType: "0",
						cellVal: '',
						updateDesc: '',
						map: {}
					},
					xfs_0_x_4: {
						cellCode: "xfs_0_" + hanh + "_4",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					xfs_0_x_4A: {
						cellCode: "xfs_0_" + hanh + "_4A",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					xfs_0_x_5: {
						cellCode: "xfs_0_" + hanh + "_5",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					xfs_0_x_5B: {
						cellCode: "xfs_0_" + hanh + "_5B",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					xfs_0_x_6: {
						cellCode: "xfs_0_" + hanh + "_6",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					xfs_0_x_6C: {
						cellCode: "xfs_0_" + hanh + "_6C",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					}
				})
				// this.selectchange(this.tableDataI[this.tableDataI.length-1])

				// this.selectchange(this.tableDataI[this.tableDataI.length - 2]);
			}
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SmallScaleVAT/index.less');
</style>